
import React from 'react';

const ResultsFooter = () => {
  return (
    <footer className="py-2 border-t border-white/10 bg-gray-900/80 backdrop-blur-md">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-muted-foreground">
          <div className="flex items-center">
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">⌘</kbd>
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">C</kbd>
            <span>Copy prompt</span>
          </div>
          <div className="flex items-center">
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">⌘</kbd>
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">R</kbd>
            <span>Regenerate</span>
          </div>
          <div className="flex items-center">
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">⌘</kbd>
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">S</kbd>
            <span>Save session</span>
          </div>
          <div className="flex items-center">
            <kbd className="px-1.5 py-0.5 bg-secondary rounded text-xs mr-1">ESC</kbd>
            <span>Back to home</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ResultsFooter;
